module.exports = __webpack_public_path__ + "static/media/wp.38a3e4b4.png";